import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sympheny-maintenance-info',
  templateUrl: './maintenance-info.component.html',
  styleUrls: ['./maintenance-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class MaintenanceInfoComponent {}
